import axios from '../utils/request';
import store from '../store';

export const getTickets = spotId => {
  const isPublic = store.getters.spotId === '0';
  if (isPublic) return axios.get('/admintickets', { params: { spot_id: spotId } });
  return axios.get('/tickets', { params: { spot_id: spotId } });
};

export const getTicketDetail = ({ id, united }) => {
  const isPublic = store.getters.spotId === '0';
  if (united) return axios.get(`/adminticket_joints/${id}`);
  if (isPublic) return axios.get(`/admintickets/${id}`);
  return axios.get(`/tickets/${id}`);
};

export const getTicketDetailSeats = ({ id, date, united }) => {
  const isPublic = store.getters.spotId === '0';
  if (united)
    return axios.get(`/admin_jointseats/${id}`, {
      params: { use_date: date },
    });
  if (isPublic) return axios.get(`/adminseats/${id}`, { params: { use_date: date } });
  return axios.get(`/seats/${id}`, {
    params: {
      use_date: date,
    },
  });
};

export const getHomePage = id => {
  const isPublic = store.getters.spotId === '0';
  if (isPublic) return axios.get('/spotindex', { params: { spot_id: id } });
  return axios.get('/index', { params: { spot_id: id } });
};

export const getSpots = params => axios.get('/spots', { params });

export const getSpotsTickets = () => axios.get('/adminticket_joints');

export const getSpotsSlides = params => axios.get('/adminindex', { params });
